import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { PagedDto } from '@/components/table/types/PagedDto.ts';
import bookingsApi from '@/features/dashboard/bookings/api/bookingsApi.ts';
import { bookingsApiQueryKeys } from '@/features/dashboard/bookings/api/bookingsApi.queryKeys.ts';
import { BookingTransactionListDto } from '@/features/dashboard/bookings/types/BookingTransactionListDto.ts';

/** Wpłaty przypisane do rezerwacji — jedna strona, komplet (patrz `getTransactions`). */
const useGetBookingTransactions = (bookingId: string | undefined) =>
  useQuery(getBookingTransactionsQueryOptions(bookingId));

export const getBookingTransactionsQueryOptions = (
  bookingId: string | undefined,
): UseQueryOptions<PagedDto<BookingTransactionListDto>> => ({
  queryKey: bookingsApiQueryKeys.transactions(bookingId ?? ''),
  queryFn: () => bookingsApi.getTransactions(bookingId!),
  enabled: !!bookingId,
  staleTime: 1000 * 60,
});

export default useGetBookingTransactions;
